export const NAME = "chats"
export const FIREBASE_PATH = "chats"
